// First import on purpose: captures and strips the autologin token before
// React renders and before analytics initialises, so a single-use credential
// never reaches GTM, the referrer, or browser history.
import './helpers/autologin';
// Same reason: the address link's token rides in the URL fragment.
import './helpers/address-link-token';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// eslint-disable-next-line import/extensions
import App from './App.js';
import { ToastContextProvider } from './contexts/toast-context-provider';
import { PaymentContextProvider } from './contexts/payment-context-provider';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  // eslint-disable-next-line react/jsx-filename-extension
  <React.StrictMode>
    <ToastContextProvider>
      <PaymentContextProvider>
        <App />
      </PaymentContextProvider>
    </ToastContextProvider>
  </React.StrictMode>,
);
